import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { grey } from '@mui/material/colors';
import { Tooltip } from '@mui/material';

const useStyle = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column-reverse',
    '& > div': {
      marginTop: 2,
      marginBottom: 2,
      textAlign: 'center',
      fontWeight: 600,
      paddingTop: 5,
      paddingBottom: 5,
      fontSize: 16,
    },
    '& > div:nth-child(n+6)': {
      color: '#fff',
    },
  },
});
const getColor = (index, length) => {
  if (length > 5) {
    switch (index) {
      case 0:
        return grey[100];
      case 1:
      case 2:
        return grey[200];
      case 3:
      case 4:
        return grey[300];
      case 5:
        return grey[400];
      case 6:
      case 7:
        return grey[500];
      case 8:
      case 9:
        return grey[600];
      case 10:
        return grey[700];
      default:
        return undefined;
    }
  }

  switch (index) {
    case 0:
      return grey[100];
    case 1:
      return grey[200];
    case 2:
      return grey[300];
    case 3:
      return grey[400];
    case 4:
      return grey[500];
    case 5:
      return grey[600];
    default:
      return undefined;
  }
};

const RatingScale = ({ data, ...props }) => {
  const classes = useStyle();

  return (
    <div className={classes.root} {...props}>
      {data.map((item, index) => (
        <div key={item.value} style={{ backgroundColor: getColor(index, data.length) }}>
          {item.tooltip ? (
            <Tooltip title={item.tooltip} placement="top">
              <div>{item.value}</div>
            </Tooltip>
          ) : (
            item.value
          )}
        </div>
      ))}
    </div>
  );
};

RatingScale.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      tooltip: PropTypes.string,
    }),
  ).isRequired,
};

export default RatingScale;
